import { esc, peso } from "../domain/format.js";

function chartLegend(series) {
  return `<div class="chart-legend">${series.map((s) => `<span><i style="background:${s.color}"></i>${esc(s.label)}</span>`).join("")}</div>`;
}

function siteBarChart(rows, series) {
  const values = rows.flatMap((r) => series.map((s) => r[s.key])),
    lo = Math.min(0, ...values),
    hi = Math.max(1, ...values),
    left = 200,
    width = 560,
    x = (v) => left + ((v - lo) / (hi - lo)) * width,
    zero = x(0),
    group = series.length * 27 + 24,
    height = rows.length * group + 58;
  if (!values.some((v) => v !== 0))
    return '<p class="muted">No amounts recorded for this selection.</p>';
  return (
    chartLegend(series) +
    `<div class="report-chart"><svg viewBox="0 0 920 ${height}" role="img" aria-label="${esc(series.map((s) => s.label).join(", "))} by location"><title>Comparison by location</title><desc>${esc(rows.map((r) => r.label + ": " + series.map((s) => s.label + " " + peso(r[s.key])).join(", ")).join("; "))}</desc><line x1="${zero}" x2="${zero}" y1="12" y2="${height - 30}" stroke="#d9d9d9"/>${rows
      .map((r, i) => {
        const y = 20 + i * group;
        return (
          `<text x="0" y="${y + 15}" fill="currentColor" font-size="13">${esc(r.label)}</text>` +
          series
            .map((s, j) => {
              const v = r[s.key],
                a = x(v),
                by = y + j * 27;
              return `<rect x="${Math.min(zero, a)}" y="${by}" width="${Math.abs(a - zero)}" height="16" rx="3" fill="${s.color}"><title>${esc(r.label + " · " + s.label + ": " + peso(v))}</title></rect><text x="790" y="${by + 13}" fill="currentColor" font-size="12">${esc(peso(v))}</text>`;
            })
            .join("")
        );
      })
      .join(
        "",
      )}<text x="${zero}" y="${height - 8}" text-anchor="middle" fill="currentColor" font-size="11">0</text></svg></div>`
  );
}

function trendChart(months, series) {
  if (!months.length || !months.some((r) => series.some((s) => r[s.key] !== 0)))
    return '<p class="muted">No activity recorded for this period.</p>';
  const values = months.flatMap((r) => series.map((s) => r[s.key])),
    lo = Math.min(0, ...values),
    hi = Math.max(1, ...values),
    x = (i) => 95 + (i * 725) / Math.max(1, months.length - 1),
    y = (v) => 250 - ((v - lo) / (hi - lo)) * 215;
  const ticks = Array.from({ length: 5 }, (_, i) => lo + ((hi - lo) * i) / 4),
    compact = (v) =>
      new Intl.NumberFormat("en-PH", {
        notation: "compact",
        maximumFractionDigits: 1,
      }).format(v / 100);
  return (
    chartLegend(series) +
    `<div class="report-chart"><svg viewBox="0 0 900 310" role="img" aria-label="Monthly revenue and expenses trend"><title>Monthly revenue and expenses</title><desc>${esc(months.map((r) => r.month + ": " + series.map((s) => s.label + " " + peso(r[s.key])).join(", ")).join("; "))}</desc>${ticks.map((v) => `<line x1="95" x2="820" y1="${y(v)}" y2="${y(v)}" stroke="#d9d9d9"/><text x="82" y="${y(v) + 4}" text-anchor="end" font-size="12" fill="currentColor">₱${esc(compact(v))}</text>`).join("")}${series.map((s) => `<polyline points="${months.map((r, i) => `${x(i)},${y(r[s.key])}`).join(" ")}" fill="none" stroke="${s.color}" stroke-width="3"/>${months.map((r, i) => `<circle cx="${x(i)}" cy="${y(r[s.key])}" r="4" fill="${s.color}"><title>${esc(r.month + " · " + s.label + ": " + peso(r[s.key]))}</title></circle>`).join("")}`).join("")}${months.map((r, i) => (i % Math.max(1, Math.ceil(months.length / 8)) === 0 || i === months.length - 1 ? `<text x="${x(i)}" y="280" text-anchor="middle" fill="currentColor" font-size="11">${esc(r.month)}</text>` : "")).join("")}</svg></div>`
  );
}

export { chartLegend, siteBarChart, trendChart };
